import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      category: 'Business',
      icon: 'fa-file-invoice-dollar',
      title: 'GST Registration',
      description: 'Quick and hassle-free GST registration with expert guidance',
      price: '₹999',
      features: ['GSTIN in 3-5 days', 'Documentation support', 'Free consultation']
    },
    {
      category: 'Business',
      icon: 'fa-building',
      title: 'Company Registration',
      description: 'Register your Private Limited, LLP, or One Person Company',
      price: '₹6,999',
      features: ['DIN & DSC included', 'MOA & AOA drafting', 'Bank account opening']
    },
    {
      category: 'Business',
      icon: 'fa-coins',
      title: 'Income Tax Filing',
      description: 'Expert ITR filing for individuals and businesses',
      price: '₹1,499',
      features: ['All ITR forms', 'E-verification', 'Tax optimization']
    },
    {
      category: 'Business',
      icon: 'fa-trademark',
      title: 'Trademark Registration',
      description: 'Protect your brand with trademark registration',
      price: '₹4,999',
      features: ['Brand search', 'Application filing', 'Response to objections']
    },
    {
      category: 'Business',
      icon: 'fa-balance-scale',
      title: 'Legal Compliance',
      description: 'Stay compliant with all statutory requirements',
      price: '₹2,999',
      features: ['Annual ROC filing', 'ESI & PF registration', 'Labour compliance']
    },
    {
      category: 'Business',
      icon: 'fa-calculator',
      title: 'Accounting & Bookkeeping',
      description: 'Professional accounting services for your business',
      price: '₹1,999/mo',
      features: ['Monthly bookkeeping', 'Financial statements', 'GST reconciliation']
    },
    {
      category: 'Business',
      icon: 'fa-certificate',
      title: 'IT Training and Certification',
      description: 'Software development and IT courses with job assistance',
      price: '₹24,999',
      features: ['Software development', 'Website development', 'Mobile app development']
    },
    {
      category: 'Business',
      icon: 'fa-clipboard-check',
      title: 'ISO Certification',
      description: 'Get ISO 9001, 14001, or other certifications',
      price: '₹14,999',
      features: ['Documentation', 'Audit support', 'Certificate issuance']
    }
  ];

  const financialServices = [
    {
      category: 'Financial',
      icon: 'fa-shield-alt',
      title: 'Insurance',
      description: 'Health, life, and business insurance plans tailored to your needs',
      price: 'Custom Plan',
      features: ['Health & Life cover', 'Business & Liability', 'Claim assistance']
    },
    {
      category: 'Financial',
      icon: 'fa-chart-line',
      title: 'Mutual Funds (SIP)',
      description: 'Goal-based SIP planning and portfolio tracking with expert guidance.',
      price: 'Coming Soon',
      features: ['Personalised SIP plans', 'Fund selection support', 'Smart portfolio rebalancing']
    },
    {
      category: 'Financial',
      icon: 'fa-file-invoice',
      title: 'Billing Application Services',
      description: 'Modern billing and invoicing application solutions tailored for your business.',
      price: 'Coming Soon',
      features: ['Custom billing workflows', 'Invoice automation', 'Planned integration with accounting systems']
    },
    {
      category: 'Financial',
      icon: 'fa-hand-holding-usd',
      title: 'Other Financial Services',
      description: 'Loans, tax-saving instruments, and comprehensive financial advisory',
      price: 'Custom Plan',
      features: ['Loan advisory', 'Tax-saving options', 'Wealth planning']
    }
  ];

  const allServices = [...services, ...financialServices];

  const handleGetStartedClick = () => {
    const element = document.getElementById('contact');
    if (!element) return;
    const headerEl = document.querySelector('.header');
    const headerOffset = headerEl ? headerEl.getBoundingClientRect().height : 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#contact');
    } else {
      window.location.hash = 'contact';
    }
  };

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>Comprehensive solutions for all your business needs</p>
        </div>
        <div className="services-grid">
          {allServices.map((service, index) => (
            <div key={index} className="service-card">
              <span className={`service-badge ${service.category === 'Financial' ? 'financial' : 'business'}`}>
                {service.category}
              </span>
              <div className="service-icon">
                <i className={`fas ${service.icon}`}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="service-price">{service.price}</div>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check"></i> {feature}
                  </li>
                ))}
              </ul>
              <button
                className="btn btn-outline"
                type="button"
                onClick={handleGetStartedClick}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
